import ManagedAccount from "@tootsweet/model/entities/ManagedAccount";
import {
  Config,
  isRepeatableCta,
  TokenHistoryLabel
} from "kadow-jetpack-model";
import { SUPPORTED_CTAS } from "./SUPPORTED_CTAS";
import sortCTAByPriority from "./sortCTAByPriority";
import { isAcquisitionCTA } from "./isAcquisitionCTA";

export function buildListOfRegularCTAsToDisplay(
  accountToDisplay: ManagedAccount | undefined,
  jetpackConfig: Config | null
) {
  let res: TokenHistoryLabel[];

  // Free
  if (!accountToDisplay?.saasFeatures) {
    res = [TokenHistoryLabel.Google];
  } else if (!accountToDisplay.saasFeatures.ctas) {
    res = [];
    // Premium
  } else if (accountToDisplay.saasFeatures.ac) {
    res = Object.values(TokenHistoryLabel) as TokenHistoryLabel[];
    // Others plans
  } else {
    res = Object.values(TokenHistoryLabel).filter((val) => {
      return !!accountToDisplay.saasFeatures?.ctas?.[val];
    }) as TokenHistoryLabel[];
  }

  return res.filter((cta) => {
    if (!SUPPORTED_CTAS.includes(cta)) {
      return false;
    }
    if (isAcquisitionCTA(cta)) {
      return false;
    }
    // Allow multiple custom CTAs
    if (cta === TokenHistoryLabel.Custom) {
      return true;
    }
    return jetpackConfig?.ctas?.findIndex((c) => c.id === cta) === -1;
  });
}

export const acquisition_cta_order = [
  TokenHistoryLabel.CheckIn,
  TokenHistoryLabel.Receipt,
  TokenHistoryLabel.Share,
  TokenHistoryLabel.Sponsorship
];

export function buildListOfAcquisitionCTAsToDisplay(
  accountToDisplay: ManagedAccount | undefined,
  jetpackConfig: Config | null | undefined
): TokenHistoryLabel[] {
  const res = Object.values(TokenHistoryLabel).filter((val) => {
    return !!accountToDisplay?.saasFeatures?.ctas?.[val];
  }) as TokenHistoryLabel[];

  const filtered = res.filter((cta) => {
    if (!SUPPORTED_CTAS.includes(cta)) {
      return false;
    }
    return isAcquisitionCTA(cta);
  });

  /**
   * Backwards compatibility with the previous version of plans
   */
  jetpackConfig?.ctas?.forEach((cta) => {
    if (
      isRepeatableCta(cta.id) &&
      filtered.findIndex((c) => c === cta.id) === -1
    ) {
      filtered.push(cta.id);
    }
  });

  return sortCTAByPriority(filtered, acquisition_cta_order);
}
